

var DB_Faqs_Categories = {
    init:function(){        
        console.log("FAQS CATEGORIES INIT");
        document.querySelectorAll(".DB-faqs__categories .tag").forEach(function(tag){
            tag.addEventListener("click", function(){
                if(tag.classList.contains("current")){
                    DB_Faqs_Categories.reboot_categories();
                }else{
                    DB_Faqs_Categories.change_categorie(tag.getAttribute("data-value"));
                }
            })
        });
    },
    change_categorie:function(value){
        document.querySelectorAll(".DB-faqs__categories .tag").forEach(function(tag){
            if(tag.getAttribute("data-value") == value){
                tag.classList.add("current");
            }else{
                tag.classList.remove("current");
            }
        });
        document.querySelectorAll(".DB-faqs .accordeon-item").forEach(function(faq){
            var _tags = faq.getAttribute("data-tags");
            if(_tags.includes(value)){
                faq.classList.remove("inactive");
            }else{
                faq.classList.add("inactive");
            }
        });
    },
    reboot_categories:function(){
        document.querySelectorAll(".DB-faqs__categories .tag").forEach(function(tag){
           tag.classList.remove("current");
        });
        document.querySelectorAll(".DB-faqs .accordeon-item").forEach(function(faq){
            faq.classList.remove("inactive");
        });
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-faqs__categories").length > 0){
        DB_Faqs_Categories.init();
    }
})